/* FRESH 32 Quiz — pure logic core. Browser global (window.QuizCore) + Node (module.exports). */
(function () {
  function genUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
    });
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function parseUTM(search) {
    var p = new URLSearchParams(search || '');
    return {
      source: p.get('utm_source') || '',
      medium: p.get('utm_medium') || '',
      campaign: p.get('utm_campaign') || '',
      content: p.get('utm_content') || '',
      term: p.get('utm_term') || ''
    };
  }

  function pickConfigSource(s) {
    s = s || {};
    var url = String(s.configUrl || '').trim();
    var inline = String(s.inlineJson || '').trim();
    var asset = String(s.assetUrl || '').trim();
    if (url) return { kind: 'url', value: url };
    if (inline) return { kind: 'inline', value: inline };
    if (asset) return { kind: 'asset', value: asset };
    return { kind: 'error', value: null };
  }

  function questionTotal(steps, mode) {
    steps = steps || [];
    if (mode === 'all_steps') return steps.length;
    return steps.filter(function (s) { return s.type === 'question'; }).length;
  }

  function computeResult(answers, scoring, steps) {
    answers = answers || {}; scoring = scoring || {}; steps = steps || [];
    var scores = {};
    (scoring.profile_vars || []).forEach(function (p) { scores[p] = 0; });

    var byId = {};
    steps.forEach(function (s) { byId[s.id] = s; });

    function selected(stepId) {
      var step = byId[stepId], ans = answers[stepId];
      if (!step || !ans || !ans.answerIds || !ans.answerIds.length) return null;
      var aid = ans.answerIds[0];
      return (step.answers || []).find(function (a) { return a.id === aid; }) || null;
    }

    (scoring.scored_steps || []).forEach(function (stepId) {
      var a = selected(stepId);
      if (a && a.score_profile) {
        scores[a.score_profile] = (scores[a.score_profile] || 0) + (typeof a.score_value === 'number' ? a.score_value : 1);
      }
    });

    var max = -1, winners = [];
    Object.keys(scores).forEach(function (p) {
      if (scores[p] > max) { max = scores[p]; winners = [p]; }
      else if (scores[p] === max) { winners.push(p); }
    });

    var profileId;
    if (max <= 0) {
      profileId = scoring.fallback_profile;
    } else if (winners.length === 1) {
      profileId = winners[0];
    } else {
      var tb = selected(scoring.tiebreaker_step);
      profileId = (tb && tb.score_profile) ? tb.score_profile : scoring.fallback_profile;
    }
    return { profileId: profileId, scores: scores };
  }

  function buildSubmissionPayload(ctx) {
    ctx = ctx || {};
    var contact = ctx.contact || {}, utm = ctx.utm || {}, result = ctx.result || {};
    return {
      quiz_id: ctx.quizId,
      quiz_version: ctx.quizVersion,
      shop_domain: ctx.shopDomain,
      page_url: ctx.pageUrl,
      session_id: ctx.sessionId,
      submitted_at: ctx.submittedAt || new Date().toISOString(),
      // The active locale of this submission (e.g. "en", "sl"). Comes from cfg.locale —
      // the locale-specific JSON file the merchant loaded. Used in Pabbly/Klaviyo to
      // branch flows or tag profiles per language.
      locale: ctx.locale || '',
      // Per-quiz tag for downstream tools (Klaviyo segment/tag, Pabbly conditional, etc.)
      lead_tag: ctx.leadTag || '',
      contact: {
        email: contact.email || '',
        first_name: contact.first_name || '',
        phone: contact.phone || '',
        marketing_consent: !!contact.marketing_consent
      },
      utm: {
        source: utm.source || '', medium: utm.medium || '', campaign: utm.campaign || '',
        content: utm.content || '', term: utm.term || ''
      },
      answers: ctx.answersDetailed || [],
      scores: ctx.scores || {},
      result: {
        profile_id: result.profileId,
        profile_title: result.profileTitle || '',
        profile_name: result.profileName || '',
        recommended_product_url: result.recommendedProductUrl || ''
      }
    };
  }

  var QuizCore = {
    genUUID: genUUID, validateEmail: validateEmail, parseUTM: parseUTM,
    pickConfigSource: pickConfigSource, questionTotal: questionTotal,
    computeResult: computeResult, buildSubmissionPayload: buildSubmissionPayload
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = QuizCore;
  if (typeof window !== 'undefined') window.QuizCore = QuizCore;
})();
